import { PcnResultTypes } from '@src/utils/enums';
import {
  handleContactDistrict,
  handleCreateRequest,
  handleDownloadLetter,
  handleAddNonPcn,
  ResultLetterDownload,
  ResultRequests,
} from '../../components/modals/self-verify-result/selfVerifyResultHelper';
import { GetJpaOrgData } from '@src/api/services/jpa/types';

export const nonPcnOutcomes = [
  PcnResultTypes.ContactDistrict,
  PcnResultTypes.NonPcnLetter,
  PcnResultTypes.PcnRequired,
  PcnResultTypes.PreApplication,
] as const;

const additionalMessage = (
  <div className='margin-top-1'>
    If you would like to attempt to prescreen for a <i>different</i> Nationwide Permit (NWP) Type for this project,
    submit another No Pre-construction Notification Required (Nationwide Permits) request by clicking the{' '}
    <b>Try a Different NWP Type</b> button below.
  </div>
);

const cancelMessage = (
  <div className='margin-top-1'>
    Click the <b>Cancel</b> button to exit back to RRS (your use of this tool has already been noted).
  </div>
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getNonPcnOutcomeContent = (orgData: GetJpaOrgData | undefined, addNonPcn: (data: any) => void) => ({
  [PcnResultTypes.ContactDistrict]: {
    content: (
      <>
        Based on the information provided, your project requires contacting the District. Click the{' '}
        <b>Contact District</b> button below to contact the District.{additionalMessage}
      </>
    ),
    onSave: () => handleContactDistrict(),
    saveText: 'Contact District',
    title: 'Your project requires contacting the district',
    canAddAnother: true,
    onAddAnother: () => handleAddNonPcn(addNonPcn),
  },
  [PcnResultTypes.NonPcnLetter]: {
    content: (
      <>
        Based on the information provided, your project does not require a Pre-construction Notification. Click the{' '}
        <b>Download Letter</b> button below to obtain your letter.
        {cancelMessage}
      </>
    ),
    onSave: () => handleDownloadLetter(ResultLetterDownload.NonPcnLetter),
    saveText: `Download Letter`,
    title: 'Your project does not require a Pre-construction Notification',
    // canAddAnother: true,
    // onAddAnother: () => handleAddNonPcn(addNonPcn),
  },
  [PcnResultTypes.PcnRequired]: {
    content: (
      <>
        Instead, the next suggested step for your project is a Pre-construction Notification. Click the{' '}
        <b>Create Request</b> button below to create an Application for Department of the Army (DA) Permit request and
        select “General Permit” when prompted for a permit type.
        {additionalMessage}
        {cancelMessage}
      </>
    ),
    onSave: () => handleCreateRequest(ResultRequests.PermitRequired, orgData),
    saveText: 'Create Request',
    title:
      'Based on the information provided, your project does not qualify for a No Pre-construction Notification Required outcome',
    canAddAnother: true,
    onAddAnother: () => handleAddNonPcn(addNonPcn),
  },
  [PcnResultTypes.PreApplication]: {
    content: (
      <>
        Instead, the next suggested step for your project is a Pre-application Meeting. Click the <b>Create Request</b>{' '}
        button below to create a Pre-application / Project Scoping request.
        {additionalMessage}
        {cancelMessage}
      </>
    ),
    onSave: () => handleCreateRequest(ResultRequests.PreApplication, orgData),
    saveText: 'Create Request',
    title:
      'Based on the information provided, your project does not qualify for a No Pre-construction Notification Required outcome',
    canAddAnother: true,
    onAddAnother: () => handleAddNonPcn(addNonPcn),
  },
});
